import React, { useState } from 'react'
import axios from 'axios'

const ContactForm = ( props) => {

    const [formSubmitted, setFormSubmitted] = useState({
        class: "",
        message: ""
    })

    const [inputName, setInputName] = useState('')
    const [inputEmail, setInputEmail] = useState('')
    const [inputCompany, setInputCompany] = useState('')
    const [inputWhatsapp, setInputWhatsapp] = useState('')

    const nameInputChangeHandler = event => setInputName(event.target.value)
    const emailInputChangeHandler = event => setInputEmail(event.target.value)
    const companyInputChangeHandler = event => setInputCompany(event.target.value)
    const whatsappInputChangeHandler = event => setInputWhatsapp(event.target.value)

    const formSubmitHandler = (e) => {
        e.preventDefault()
        axios({
            url: `${ process.env.GATSBY_STRAPI_URL }/contacts`,
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            data: {
                'name': inputName,
                'email': inputEmail,
                'company': inputCompany,
                'whatsapp': inputWhatsapp,
            }
        })
        .then(response => {
            console.log(response)
            setFormSubmitted({
                class: "mb-2",
                message: "Thank you for your submission."
            })
            props.setDisplayForm(false)
            setInputName('')
            setInputEmail('')
            setInputCompany('')
            setInputWhatsapp('')
        })
        .catch(error => {
            console.log(error)
            setFormSubmitted({
                class: "text-red mb-2",
                message: "Sorry something is not right. Please try submitting the form again later."
            })
        })
    }

    return (
        <>
            { props.displayForm && <h5 className="text-xl font-bold mb-8">Please fill in this form</h5> }
            <form name="prelaunch-contact-form" method="POST" onSubmit={formSubmitHandler}>
                <div className="grid grid-flow-row gap-3">
                    { props.displayForm &&
                        <>
                        <div>
                            <label for="prelaunch-contact-name" className="text-sm text-primary mb-1 font-bold block">Name</label>
                            <input id="prelaunch-contact-name" type="text" name="prelaunch-contact-name" placeholder="" required className="border border-gray-800 border-solid px-4 py-2 w-full" onChange={ nameInputChangeHandler } value={ inputName } />
                        </div>
                        <div>
                            <label for="prelaunch-contact-email" className="text-sm text-primary mb-1 font-bold block">Email</label>
                            <input id="prelaunch-contact-email" type="email" name="prelaunch-contact-email" placeholder="" required className="border border-gray-800 border-solid px-4 py-2 w-full" onChange={ emailInputChangeHandler } value={ inputEmail } />
                        </div>
                        <div>
                            <label for="prelaunch-contact-company" className="text-sm text-primary mb-1 font-bold block">Company</label>
                            <input id="prelaunch-contact-company" type="text" name="prelaunch-contact-company" placeholder="" required className="border border-gray-800 border-solid px-4 py-2 w-full" onChange={ companyInputChangeHandler } value={ inputCompany } />
                        </div>
                        <div>
                            <label for="prelaunch-contact-whatsapp" className="text-sm text-primary mb-1 font-bold block">WhatsApp Number</label>
                            <input id="prelaunch-contact-whatsapp" type="tel" pattern="[0-9]+" name="prelaunch-contact-whatsapp" placeholder="" required className="border border-gray-800 border-solid px-4 py-2 w-full" onChange={ whatsappInputChangeHandler } value={ inputWhatsapp } />
                        </div>
                        <div>
                            <button type="submit" name="submit" className="h-12 bg-black text-white font-bold px-4 rounded-xl">Register</button>
                        </div>
                        </>
                    }
                    { formSubmitted && <div><p className={ formSubmitted.class }>{ formSubmitted.message }</p></div> }
                </div>
            </form>
        </>
    )
}

export default ContactForm
